import { render, staticRenderFns } from "./VAdminServiceCard.vue?vue&type=template&id=49ef8483"
import script from "./VAdminServiceCard.vue?vue&type=script&lang=js"
export * from "./VAdminServiceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports